// TODO: Import React module
import * as React from 'react';
//import ReactAudioPlayer from 'react-audio-player';
import ReactPlayer from 'react-player/file';

// TODO: Import MUI module
import Box from '@mui/material/Box';
import { Avatar, Grid, Card, CardContent, Divider, Stack, Typography } from '@mui/material';

// TODO: Import custom component
import { ContentTitle, } from '../Common/TypographyTYH';
import BoxImage from '../Common/BoxImage';

// TODO: Import context
import { Context } from '../Common/Context';
import { Text } from '../Common/Text';

const Graduation = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component Graduation Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable
    const data = [{
        year: 2026,
        name: '前行',
        description: '<p>作曲：顏浩然<br>填詞：顏浩然<br>編曲：顏浩然，馬晉煒<br>演唱：Notation(顏浩然、孫暉喬、梁凱怡、鄧凱琳、馬晉煒)</p>',
        Youtube: 'https://www.youtube.com/embed/si8C9wi_UcI',
    }, {
        year: 2025,
        name: '少年的故事',
        description: '<p>創作：葉雅晴 / 林子樂<br>編曲：朱慧敏老師</p>',
        filename: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/2425.wav',
        Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/2425.jpg',
    }, {
        year: 2024,
        name: '離別的回眸',
        description: '<p>創作：黃柏銘 / 梅文熙<br><br></p>',
        filename: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/2324.mp3',
        Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/2324.jpg',
    }, {
        year: 2023,
        name: '唱一首歌給我',
        description: '<p>曲詞：6A 李昊樺<br>編：6A 李昊樺 / 朱慧敏老師<br>唱：6E葉學賢 / 蔡濬溱老師 / 黃偉豪老師</p>',
        filename: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/2223.wav',
        Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/2223.jpg',
    }, {
        year: 2022,
        name: 'Everything will be OK',
        description: '<p>創作：呂依銘師姐 / 校友陳凱迪<br><br><br></p>',
        filename: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/2122.mp3',
        Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/2122.jpg',
    }, {
        year: 2021,
        name: 'It\'s time to say goodbye',
        description: '<p>創作:黃淑嫻/胡胤廷/林朗傑<br>主唱:趙詠琪/胡胤廷<br>樂器演奏:林朗傑/黃淑嫻<br>編曲:胡胤廷</p>',
        filename: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/2021.mp3',
        Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/2021.jpg',
    }, {
        year: 2020,
        name: '結伴',
        description: '<p>創作:劉慧珍/禤漢彬/余鎧軒/高梓桓/葉雅姿/吳婉婷<br>主唱:李藹盈/禤漢彬/余鎧軒/吳婉婷/謝詩呈/葉雅姿<br>樂器演奏:Drum:謝梓聰/Saxophone:葉青霖<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Flute:劉慧珍/Trombone:柳鈺晶<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Eurphonium:高梓桓<br>編曲:朱慧敏老師</p>',
        filename: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/1920.mp3',
        Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/1920.jpg',
    }, {
        year: 2019,
        name: '我倆',
        description: '<p>創作:翁羨桐/賴曉藍<br>主唱:何曉晴/謝天恩<br>樂器演奏:Violin:駱昕/Flute:吳嘉蔚/翁羨桐<br>編曲:朱慧敏老師</p>',
        filename: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/1819.mp3',
        Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/1819.jpg',
    }, {
        year: 2018,
        name: '相約在走廊',
        description: '<p>創作:朱慧敏老師<br>主唱:陳靖嵐/廖卓琳<br>編曲:朱慧敏老師<br><br></p>',
        filename: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/1718.mp3',
        Image: 'https://www.pohtyh.edu.hk/Files/MusicalWork/Graduation/1718.jpg',
    },];

    // TODO: Define event

    // TODO: Define function

    // TODO: Return component
    return (
        <Stack className="SectionGraduation" spacing={2} sx={{ alignItems: 'center', m: 5 }}>
            <ContentTitle text={Text.MusicalWork.Graduation[context.language]} />
            <Grid container spacing={2}>
                {
                    data.map((item, i) => (
                        <Grid key={i} size={{ xs: 12, md: 6 }}>
                            <Card
                                key={i}
                                sx={{
                                    alignItems: 'center',
                                    backgroundColor: 'tertiary.main',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: 1,
                                    justifyContent: 'start',
                                    p: 2
                                }}
                            >
                                <CardContent key={i} sx={{ p: 1, width: 1 }}>
                                    <Stack alignItems="center" direction="row" spacing={2}>
                                        <Avatar sx={{ fontSize: '1rem' }}>{item.year}</Avatar>
                                        <Typography
                                            color="black"
                                            dangerouslySetInnerHTML={{ __html: item.name }}
                                            variant="subtitle1"
                                        />
                                    </Stack>
                                    <Box sx={{ width: 1 }}>
                                        <Typography
                                            color="text.secondary"
                                            dangerouslySetInnerHTML={{ __html: item.description }}
                                            variant="subtitle2"
                                        />
                                        {item.Youtube
                                            ? <iframe
                                                src={`${item.Youtube}`}
                                                style={{ aspectRatio: '16/9', border: 0, width: '100%', height: '100%' }}
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                                title={item.name}
                                            ></iframe>
                                            : <ReactPlayer
                                                controls={true}
                                                width="100%"
                                                height="80px"
                                                url={item.filename}
                                            />}
                                    </Box>
                                </CardContent>
                                {!item.Youtube && <BoxImage src={item.Image} sx={{ mt: 1, width: 1 }} />}
                            </Card>
                        </Grid>
                    ))
                }
            </Grid>
            <Divider variant="inset" />
        </Stack>
    );
};
export default Graduation;